import { createElement } from 'react';
import cn from 'classnames';
import { useCurrentMenu } from '../Context.js';
import { Label } from '@radix-ui/react-dropdown-menu';

const Header = props => {
  const menu = useCurrentMenu();
  const className = cn('flex items-center justify-start h-7 pr-1.5 text-xs text-grey-darkest', {
    'pl-7': menu === null || menu === void 0 ? void 0 : menu.indented,
    'pl-1.5': !(menu !== null && menu !== void 0 && menu.indented)
  }, props.className);
  return createElement(Label, Object.assign({}, props, {
    className: className
  }));
};

export { Header };
//# sourceMappingURL=Header.js.map
